import { all } from 'redux-saga/effects';
import productsSagas from './products/saga';
import purchaseSagas from './purchase/saga';
import collaboratorSagas from './collaborator/saga';
import groupSagas from './group/saga';
import assignorSagas from './assignor/saga';

export default function* rootSaga() {
  yield all([productsSagas(), purchaseSagas(), collaboratorSagas(), groupSagas(), assignorSagas()]);
}
